module.exports = __webpack_public_path__ + "static/media/kelloggs choco.5bd8ed44.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/kelloggs choco.gif
// module id = 369
// module chunks = 0